/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsAdditionalUploads204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsAdditionalUploads505Schema = z.any();

export const optionsAdditionalUploadsMutationResponseSchema = z.lazy(() => optionsAdditionalUploads204Schema);
